<template>

    <q-card class=" col-12 q-ma-sm  row justify-end" style="width: 500px; max-width: 80vw">
        <div class=" col-12 text-center q-ma-md" v-if="loading">
            <p class="text-h5">{{ titulo }}</p>
            <q-circular-progress indeterminate rounded size="50px" color="orange" class="q-ma-md text-center" />
        </div>
        <div class="col-12" v-if="!loading">
            <q-card-section class="bg-grey-8 text-white">
                <p class="text-h5 q-mb-xs">Promociones</p>
            </q-card-section>
            <q-card-section class="bg-red-8 text-white q-pa-xs" v-if="mensaje_error != ''">
                <p class="text-subtitle2 q-my-sm">{{ mensaje_error }}</p>
            </q-card-section>
            <!-- <hr> -->
            <div class="col-12" v-if="paso == 1">
                <div v-if="!promociones.length == 0">
                    <q-card class=" col-12 q-ma-sm q-pa-sm row" flat v-for="promo in promociones" :key="promo">
                        <div class="col-8 col-sm-8">
                            <b class="text-body1">{{ promo.nombre_promocion }}</b><br><i>{{ promo.detalle_promocion
                                }}</i>
                        </div>
                        <div class="col-4 col-sm-4">
                            <q-btn label="Seleccionar" :disabled="verificando" rounded outline color="green" size="sm"
                                :loading="verificando && cupon_actual == promo.codigo_cupon" class="float-right"
                                @click="promo.codigo_cupon; verificar_cupon(promo.codigo_cupon)" />
                        </div>
                    </q-card>
                </div>
                <div class="col-12  q-px-md text-end row" v-if="(paso == 1 && tipo != 'promociones')">
                    <q-input :disable="verificando" outlined v-model="cupon_input" label="Ingrese un cupón de descuento"
                        class="q-mt-md col-12" />
                    <q-btn label="Verificar" :loading="verificando" rounded outline :disabled="cupon_input.length < 4"
                        @click="verificar_cupon()" color="blue" size="md" class="q-my-md " />
                </div>
            </div>
            <div class="col-12" v-if="paso == 2 && error_critico == false">
                <q-card class=" col-12 q-ma-md" flat>
                    <div class="text-h6 text-center text-weight-regular"> {{ promocion.titulo }}</div>
                    <div class="text-h6 text-center text-italic"> {{ promocion.titulo_negrita }}</div>
                    <q-btn color="primary"
                        :outline="(entradas_seleccionadas[entrada.venta_ubicacion] == null && entradas_usadas[entrada.venta_ubicacion] == null) ? true : false"
                        :disabled="(entradas_usadas[entrada.venta_ubicacion] != null || aplicando_descuento)"
                        class="q-ma-md" v-for="entrada in promocion.entradas_validas" :key="entrada"
                        @click="seleccionar_entrada(entrada)">
                        {{ entrada.texto }}<br><s style="margin-right:5px;">{{ entrada.precio_tachado }}</s> {{
                            entrada.precio }} <q-icon name="check"
                            v-if="(entradas_usadas[entrada.venta_ubicacion] != null)"></q-icon>
                    </q-btn>
                    <!-- <div class="text-h6 text-center text-italic"> {{ promocion.pie }}</div> -->
                    <div class="text-h6 text-center text-bold" v-if="mensaje != ''"> {{ mensaje }}</div>
                    <q-circular-progress indeterminate rounded size="20px" color="orange"
                        class="q-ma-md text-center col12" v-if="aplicando_descuento" />
                    <!-- <hr> -->
                    <q-btn label="Cerrar" v-close-popup class="q-mt-lg" />
                </q-card>
            </div>
            <div class="col-12" v-if="error_critico == true">
                <div class="text-h6 text-center text-bold"> Ocurrió un error grave, reinicie la operación</div>
            </div>
        </div>
    </q-card>
</template>

<script setup>
// @ is an alias to /src
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { useEPStore } from "@/store/store";
import axios from "axios";
const store = useEPStore();
const router = useRouter();
const promociones = ref([])

const titulo = ref("Cargando promociones")
const mensaje = ref("")
const aplicando_descuento = ref(false)
const error_critico = ref(false)
const mensaje_error = ref("")
const loading = ref(true)
const verificando = ref(false)
const cupon_input = ref("")
const cupon_actual = ref("")
const paso = ref(1)
const promocion = ref([])
const entradas_seleccionadas = ref({})
const entradas_usadas = ref({})
const tipo = ref("cupones")
function obtener_cupones_activos() {
    axios
        .get(
            `${store.host}/webapp/obtener_promociones_activas?${store.obtener_credenciales()}`
        )
        .then(({ data }) => {

            if (data.promociones != null) {
                promociones.value = data.promociones
            }
            if (promociones.value.length != 0) {
                tipo.value = "promociones"

            }
            loading.value = false;
        })
        .catch((e) => {
            loading.value = false;
            //   venta.verificando = false;
        });
}


function verificar_cupon(cupon) {
    mensaje_error.value = ""
    verificando.value = true;
    cupon_actual.value = (cupon != null) ? cupon : cupon_input.value

    axios
        .get(
            `${store.host}/webapp/verificar_cupon?${store.obtener_credenciales()}&cod_cupon=${cupon_actual.value}`
        )
        .then(({ data }) => {
            verificando.value = false;
            if (data.Result == "mostrar_lista" && data.promocion.entradas_validas != null) {

                promocion.value = data.promocion
                if (promocion.value.pie != null && promocion.value.pie != "") {
                    mensaje.value = promocion.value.pie
                }
                paso.value = 2
            } else {
                if (data.Message != "") {
                    mensaje_error.value = data.Message
                }
            }
        })
        .catch((e) => {
            // loading.value = false;
            verificando.value = false;
            mensaje_error.value = "Ocurrió un error en el servidor"
        });
}


function seleccionar_entrada(entrada) {
    mensaje_error.value = ""
    if (entradas_seleccionadas.value[entrada.venta_ubicacion] != null) {
        delete (entradas_seleccionadas.value[entrada.venta_ubicacion])
    } else {
        entradas_seleccionadas.value[entrada.venta_ubicacion] = false

    }
    if (Object.keys(entradas_seleccionadas.value).length == promocion.value.pack) {
        aplicar_descuento()
    }
    console.log((Object.keys(entradas_seleccionadas.value).length == promocion.value.pack))
    console.log(entradas_seleccionadas.value)
}

function aplicar_descuento() {
    aplicando_descuento.value = true;
    mensaje_error.value = ""
    mensaje.value = "Aplicando descuento, aguarde..."
    const formData = new FormData();
    formData.append("cod_cupon", cupon_actual.value);
    let extra_query = ""
    let marcar_entradas = []
    for (let entr in entradas_seleccionadas.value) {
        console.log(entr)
        if (entradas_seleccionadas.value[entr] == false) {
            console.log("INGRESADO!")
            formData.append("entrada_id[]", entr);
            extra_query += "&entrada_id[]=" + entr
            marcar_entradas.push(entr)
        }
    }
    axios
        .post(`${store.host}/webapp/verificar_cupon?${store.obtener_credenciales()}&cod_cupon=${cupon_actual.value}${extra_query}`, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        .then(({ data }) => {
            aplicando_descuento.value = false;
            mensaje.value = ""
            if (data.Result == "ok") {
                store.obtener_carrito()
                mensaje.value = data.Message
                for (let tmp in marcar_entradas) {
                    entradas_usadas.value[marcar_entradas[tmp]] = true;
                }
                entradas_seleccionadas.value = {}
            } else {
                if (data.Message != "") {
                    mensaje_error.value = data.Message
                    entradas_seleccionadas.value = {}
                }

            }
            console.log(data)
        }).catch((e) => {
            aplicando_descuento.value = false;
            mensaje.value = ""
            entradas_seleccionadas.value = {}
            mensaje_error.value = "Ocurrió un error en el servidor"
        });

}


onMounted(() => obtener_cupones_activos());
</script>
